import { t } from "@/i18n-js/instance";
import { useImagePostModal } from "@/react/components/Modals/ImagePostModal";
import { Button } from "@circle-react-uikit/Button";

interface NewImagePostButtonProps {
  spaceId: number;
}
export const NewImagePostButton = ({ spaceId }: NewImagePostButtonProps) => {
  const imagePostModal = useImagePostModal();

  return (
    <Button
      type="button"
      large
      variant="primary"
      className="hidden md:flex"
      onClick={() =>
        imagePostModal.show({
          spaceId,
          onClose: () => imagePostModal.remove(),
        })
      }
    >
      {t("new_post")}
    </Button>
  );
};
